module.exports = __webpack_public_path__ + "static/media/call-answer.af51c4c7.svg";